import { useTranslate } from "@refinedev/core";
import { ViewerActivityEvent } from "types";

const T_PREFIX = "media.projects.analytics.activity";

// The mockup shows an incrementing "Viewer #N", but the API has no natural
// ordinal — a counter based on load-order would shift across
// pagination/refetch and misrepresent viewer identity. The truncated
// viewer_id is stable across pages instead.
export function getViewerDisplayName(
  event: Pick<ViewerActivityEvent, "firstname" | "lastname" | "email" | "viewer_id">,
  t: ReturnType<typeof useTranslate>
): string {
  const fullName = [event.firstname, event.lastname]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (fullName) return fullName;
  if (event.email) return event.email;
  return t(`${T_PREFIX}.viewerFallback`, { id: event.viewer_id.slice(0, 6) });
}
